import TypeCheck from "../../utils/Typecheck";

export enum ComplectationAttributeType {
    tabs = 'tabs',
    tags = 'tags',
    select = 'select',
}

export const isComplectationAttributeType = (content: unknown): content is ComplectationAttributeType => {
    return TypeCheck.isString(content)
        && TypeCheck.isEnumValue(content, ComplectationAttributeType);
};
